import { useCallback, useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../Components/LanguageContext';
import handleTransformLang from '../functions/handleTransformLang';
import brandsContent from '../lang/components/brands.json';
import brandsData from '../lang/brands.json'

const Brands = () => {
    const { language } = useContext(LanguageContext);

    const [maxValue, setMaxValue] = useState(30);
    const [showAll, setShowAll] = useState(false);
    const [content, setContent] = useState(handleTransformLang(brandsContent));

    const handleWindowResize = useCallback(event => {
        handleMaxBrandsToShow()
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        handleMaxBrandsToShow()
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [handleWindowResize]);

    useEffect(() => {
        setContent(handleTransformLang(brandsContent));
    }, [language]);

    function handleMaxBrandsToShow() {
        if (window.innerWidth >= 1280) {
            setMaxValue(30)
            setShowAll(true)
        } else if (window.innerWidth >= 1024) {
            setMaxValue(20)
            setShowAll(false)
        } else if (window.innerWidth >= 768) {
            setMaxValue(15)
            setShowAll(false)
        } else {
            setMaxValue(10)
            setShowAll(false)
        }
    }

    function showAllClicked() {
        setShowAll(true)
        setMaxValue(30)
        window.removeEventListener('resize', handleWindowResize);
    }

    return (
      <div className="mx-auto max-w-8xl px-4 h-fit flex flex-col">
        <div className="hidden h-fit 1.5xl:grid 1.5xl:grid-cols-6 1.5xl:py-11"> 
            {Object.values(brandsData).map((brand) =>
                <div className={`group min-h-fit w-full flex flex-col justify-center px-10 py-8 border-s
                    [&:nth-child(6n+1)]:border-s-0 [&:nth-child(n+7)]:border-t [&:nth-child(n+7)]:py-12`}
                    key={`${brand.brandName}-desktop`}
                >
                    <div className="relative h-26 w-40 flex flex-col">
                        <img className="absolute inset-0 group-hover:opacity-0 opacity-100 object-contain w-full h-full
                                        transition-opacity ease-in-out duration-300"
                            src={brand.image}
                            alt={brand.brandName}
                        />
                        <img className="absolute inset-0 group-hover:opacity-100 opacity-0 object-contain w-full h-full
                                        transition-opacity ease-in-out duration-300"
                            src={brand.hoverImage}
                            alt={brand.brandName}
                        />
                    </div>
                </div>
            )}
        </div>

        <div className="h-fit grid 1.5xl:hidden xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 py-8 md:py-11"> 
            {Object.values(brandsData).map((brand, index) =>
                { if(index < maxValue) {
                    return <div className={`group min-h-fit w-full flex flex-col justify-center px-10 py-8 border-s
                        1.5xl:[&:nth-child(5n+1)]:border-s-0 1.5xl:[&:nth-child(n+6)]:border-t 1.5xl:[&:nth-child(n+6)]:py-12
                        xl:max-1.5xl:[&:nth-child(4n+1)]:border-s-0 xl:max-1.5xl:[&:nth-child(n+5)]:border-t xl:max-1.5xl:[&:nth-child(n+5)]:py-12
                        lg:max-xl:[&:nth-child(4n+1)]:border-s-0 lg:max-xl:[&:nth-child(n+5)]:border-t lg:max-xl:[&:nth-child(n+5)]:py-12
                        md:max-lg:[&:nth-child(3n+1)]:border-s-0 md:max-lg:[&:nth-child(n+4)]:border-t md:max-lg:[&:nth-child(n+4)]:py-12
                        max-md:[&:nth-child(2n+1)]:border-s-0 max-md:[&:nth-child(n+3)]:border-t max-md:[&:nth-child(n+3)]:py-10 max-md:px-8`}
                        key={brand.brandName}
                    >
                        <div className="relative smm:w-40 smm:h-26 h-16 w-24 md:w-28 lg:w-32 flex flex-col object-contain">
                            <img className="absolute inset-0 group-hover:opacity-0 opacity-100 object-contain w-full h-full
                                            transition-opacity ease-in-out duration-300"
                                src={brand.image}
                                alt={brand.brandName}
                            />
                            <img className="absolute inset-0 group-hover:opacity-100 opacity-0 object-contain w-full h-full
                                            transition-opacity ease-in-out duration-300"
                                src={brand.hoverImage}
                                alt={brand.brandName}
                            />
                        </div>
                    </div>
                } else return null;
                }
            )}
        </div>
        {!showAll && 
            <div className="w-full h-fit flex flex-col text-center items-center pt-1">
                <button onClick={showAllClicked} className='text-text_tertiary text-[15px] md:text-[16px] font-medium'>
                    {content.showAll}
                </button>
                <span className="mt-1 text-text_tertiary text-xl leading-none">⌄</span>
            </div>
        }
      </div>
    )
}
export default Brands;
